export enum CalendarViewEnum {
  Day = 'day',
  Month = 'month',
  Year = 'year',
}

export enum RangeSelectionFieldEnum {
  StartDate = 'startDate',
  EndDate = 'endDate',
}

export enum HoverExtendedRangePositionEnum {
  None = 'none',
  Left = 'left',
  Right = 'right',
  Middle = 'middle',
  Single = 'single',
}

export enum DateRangeDropdownOptionEnum {
  Tomorrow = 'tomorrow',
  OneWeek = 'oneWeek',
  OneMonth = 'oneMonth',
  CustomDate = 'customDate',
}
